export default "/images/star.svg?8070f2335a60a0172b4cde8fddb5b020";